/** Blob responses also carry ABP error payloads on failed downloads. */
export async function getExcelExportErrorKey(error: unknown): Promise<string> {
  let body = (error as { error?: unknown } | null)?.error;
  if (body instanceof Blob) {
    try {
      body = JSON.parse(await body.text());
    } catch { body = undefined; }
  }
  const code = (body as { error?: { code?: string } } | null)?.error?.code;
  if (code === 'Projection:ExcelRowLimitExceeded') {
    return 'ExcelExportRowLimitExceeded';
  }
  if (code === 'Projection:InvalidExcelFields') {
    return 'ExcelExportInvalidFields';
  }
  return 'ExcelExportError';
}
